import CustomButton from '@/components/common/button';
import LoginErrorIcon from '@/helpers/svg/loginErrorIcon.svg';
import { Checkbox, Input, Modal, ModalBody, ModalContent, ModalFooter, Textarea } from '@nextui-org/react';
import Link from 'next/link';
import React from 'react';
import { IoLogIn } from 'react-icons/io5';
import { useSelector } from 'react-redux';
import { getPathname } from '@/helpers/browser.utils';

const UserReport = ({ isOpen, onClose, data, }) => {
    const { profile } = useSelector(state => state.Auth)
    return (
        <>
            <Modal
                backdrop="blur"
                isOpen={isOpen}
                size={profile.isLogin ? "3xl" : 'lg'}
                onClose={onClose}
                className="bg-[#262626]"
            >
                <ModalContent>
                    <>
                        {
                            profile.isLogin ? (
                                <ModalBody className="p-12 dark">
                                    <h3 className="text-white"> محتوا چه مشکلی دارد؟</h3>
                                    <div className="flex flex-col ">
                                        <div className="flex flex-col justify-center items-start">
                                            <span className="text-primary-white text-xl mb-2">
                                                نام فیلم
                                            </span>
                                            <div className="w-full min-h-[70px]">
                                                <Input
                                                    variant="bordered"
                                                    className="h-[30px] bg-transparent w-full lg:max-w-full mb-3 text-white"
                                                    value={data?.title}
                                                    size="lg"
                                                    readOnly
                                                    disabled
                                                />
                                            </div>
                                        </div>
                                        <div className="flex flex-wrap md:flex-nowrap justify-start gap-5 md:gap-14 items-center">
                                            <Checkbox color="primary">
                                                <span className="text-primary-white text-md md:text-lg">
                                                    ایراد ممیزی دارد
                                                </span>
                                            </Checkbox>
                                            <Checkbox color="primary">
                                                <span className="text-primary-white text-md md:text-lg">
                                                    پخش نمیشود
                                                </span>
                                            </Checkbox>
                                            <Checkbox color="primary">
                                                <span className="text-primary-white text-md md:text-lg ">
                                                    زیرنویس مشکل دارد
                                                </span>
                                            </Checkbox>
                                        </div>
                                        <div className="flex flex-col justify-center items-start">
                                            <div className="w-full">
                                                <Textarea
                                                    variant="bordered"
                                                    placeholder="توضیحات"
                                                    className="bg-transparent w-full lg:max-w-full my-3 text-white"
                                                    size="lg"
                                                    minRows={4}
                                                    maxRows={6}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </ModalBody>
                            ) : (
                                <ModalBody className="p-12 pb-0 dark">
                                    <IoLogIn size={72} className='mx-auto mb-5' color='white' />
                                    <h3 className="text-white text-center">برای ثبت گزارش کاربر ابتدا باید وارد حساب کاربری خود شوید</h3>

                                </ModalBody>
                            )
                        }
                        <ModalFooter>
                            {profile.isLogin ? (<div className="w-full">
                                <CustomButton
                                    fullWidth
                                    label="ارسال گزارش"
                                    color="primary"
                                    classNames={"min-h-[50px]"}
                                    textColor="text-primary-white"
                                />
                            </div>) : (
                                <div className="w-full">
                                    <Link className='w-full' href={'/auth/login?ref' + encodeURIComponent(getPathname())}>
                                        <CustomButton
                                            fullWidth
                                            label="ورود به حساب کاربری"
                                            color="primary"
                                            classNames={"min-h-[50px]"}
                                            textColor="text-primary-white"
                                        /></Link>
                                </div>
                            )}
                        </ModalFooter>
                    </>
                </ModalContent>
            </Modal>
        </>
    );
}

export default UserReport;